import { render } from "./TransactionListItem.vue?vue&type=template&id=0824bcf9"
import script from "./TransactionListItem.vue?vue&type=script&lang=ts"
export * from "./TransactionListItem.vue?vue&type=script&lang=ts"
script.render = render

export default script